import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

export const HomePageLink: React.FC = () => {
    return (
        <Link to={`/home`}>
            <span className='icon'>
                <FontAwesomeIcon icon={faChevronLeft} />
            </span>
            &nbsp;
            <i>Home Page</i>
        </Link>
    );
};
